import {
  CATEGORIES,
  CREATED_DATE_VALUES,
  POLL_AND_QUIZ_SUBTYPE,
  QUESTION_TYPES,
  RESULTS_VISIBILITY,
  SUBTYPE_NOT_APPLICABLE
} from '../constants/appConstants';
import {faker} from '@faker-js/faker';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import paella from '../static/images/paella.jpg'
// import image1 from "../static/images/image1.jpg"

const getRandomOptions = (count = 4, wordCount = 30) => {
  const randomOptions = []
  for (let i = 0; i < count; i++) {
    randomOptions.push(faker.word.sample({min: 10, max: wordCount}))
  }
  return randomOptions
}

const getHashTags = (count = 3, wordCount = 10) => {
  const hashtags = []
  for (let i = 0; i < count; i++) {
    hashtags.push(faker.word.sample({min: 10, max: wordCount}))
  }
  return hashtags
}

const getRandomCategory = () => {
  return CATEGORIES[faker.helpers.arrayElement(Object.keys(CATEGORIES))]
}

const getCommonParams = () => {
  return {
    title: faker.lorem.sentence(15),
    createdBy: faker.person.fullName(),
    category: getRandomCategory(),
    hashtags: getHashTags(),
    createdDate: CREATED_DATE_VALUES,
    expiryDate: faker.date.future(),
    options: getRandomOptions(),
    questionType: QUESTION_TYPES.POLL,
    subType: POLL_AND_QUIZ_SUBTYPE.TEXT,
    description: faker.lorem.sentence(100),
    
    settings: {
      resultsVisibility: RESULTS_VISIBILITY.PUBLIC_AFTER_VOTE,
      showOptionsOnLoad: true,
      solveQuestion: true,
      changeVote: false,
      hint: true,
      isStartButtonRequired: true,
    }
  }
}

export const questionSingle = () => {
  return {
    ...getCommonParams(),
    questionType: QUESTION_TYPES.POLL,
    subType: POLL_AND_QUIZ_SUBTYPE.TEXT,
  }
}

export const WORDLE_Q = {
  ...getCommonParams(),
  questionType: QUESTION_TYPES.WORDLE,
  subType: QUESTION_TYPES.WORDLE,
}

export const question = () => {
  return [
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.JIGSAW_PUZZLE,
      subType: QUESTION_TYPES.JIGSAW_PUZZLE,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.CROSS_WORD_PUZZLE,
      subType: QUESTION_TYPES.CROSS_WORD_PUZZLE
    },
    WORDLE_Q,
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.IMAGE_SWAP,
      subType: QUESTION_TYPES.IMAGE_SWAP,
    },

    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.SPIN_A_WHEEL,
      subType: SUBTYPE_NOT_APPLICABLE,
      settings: {
        ...getCommonParams().settings,
        solveQuestion: false
      }
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.MARKS,
      subType: SUBTYPE_NOT_APPLICABLE,
      
      settings: {
        ...getCommonParams().settings,
        solveQuestion: false,
        isStartButtonRequired: false,
      }
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.MATH_SQUARE,
      subType: SUBTYPE_NOT_APPLICABLE,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.IMAGE_WORD_PUZZLE,
      subType: SUBTYPE_NOT_APPLICABLE,
    },
    // OLD
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.POLL,
      subType: POLL_AND_QUIZ_SUBTYPE.TEXT,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.POLL,
      subType: POLL_AND_QUIZ_SUBTYPE.IMAGE,
      imageUrl: [paella, paella, paella],

    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.POLL,
      subType: POLL_AND_QUIZ_SUBTYPE.MULTI_CHOICE_TEXT,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.QUIZ,
      subType: POLL_AND_QUIZ_SUBTYPE.TEXT,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.QUIZ,
      subType: POLL_AND_QUIZ_SUBTYPE.IMAGE,
      imageUrl: [paella, paella, paella],
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.QUIZ,
      subType: POLL_AND_QUIZ_SUBTYPE.MULTI_CHOICE_TEXT,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.QUIZ,
      subType: POLL_AND_QUIZ_SUBTYPE.TEXT,
      settings: {
        ...getCommonParams().settings,
        showOptionsOnLoad: false
      }
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.RANK,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.FACT,
    },
    {
      ...getCommonParams(),
      questionType: QUESTION_TYPES.RATING,
      subType: POLL_AND_QUIZ_SUBTYPE.RATING
    },
    {
      ...getCommonParams(),
      settings: {
        ...getCommonParams().settings,
        resultsVisibility: RESULTS_VISIBILITY.NOT_PUBLIC
      }
    },
    {
      ...getCommonParams(),
      settings: {
        ...getCommonParams().settings,
        resultsVisibility: RESULTS_VISIBILITY.PUBLIC_AFTER_END_DATE
      }
    }

  ]
}

export const getCategories = (count = 10) => {
  const categories = []
  for (let i = 0; i < count; i++) {
    categories.push({
      label: faker.word.adjective(),
      icon: faker.helpers.arrayElement([
        <AcUnitOutlinedIcon/>,
        <AccountTreeOutlinedIcon/>,
        <AirportShuttleOutlinedIcon/>,
        <TheaterComedyOutlinedIcon/>])
    })
  }

  return categories
}
